export default __webpack_public_path__ + "static/media/3.aba88042.jpg";